export default __webpack_public_path__ + "static/bg-data-hexagons-mobile-55c4e3ffe4f66731d6c89be77e27a980.png";